export const PERMISSIONS = {
  POS_VIEW: "POS_VIEW",
  KIOSK_VIEW: "KIOSK_VIEW",
  KDS_VIEW: "KDS_VIEW",
  ORDER_DISPLAY_VIEW: "ORDER_DISPLAY_VIEW",
  QR_VIEW: "QR_VIEW",
  ONLINE_ORDERING_VIEW: "ONLINE_ORDERING_VIEW",
};

const normalizePermissions = (permissions) => {
  if (!permissions) return [];
  if (Array.isArray(permissions)) return permissions.filter(Boolean);
  if (typeof permissions === "string") {
    try {
      const parsed = JSON.parse(permissions);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch {
      // ignore parse error
    }
    return permissions.split(",").map((item) => item.trim()).filter(Boolean);
  }
  return [];
};

export const getUserPermissions = (user) => {
  return normalizePermissions(user?.permissions);
};

export const hasPermission = (user, permission) => {
  if (!permission) return true;
  const permissions = getUserPermissions(user);
  return permissions.includes(permission);
};
